import type { Lang } from "@shared/types";
import { api } from "./api";
import { IS_DEMO } from "./asset";
import { createStore, useStore } from "./store";

export interface User {
  id: number;
  username: string;
  displayName: string;
  email: string | null;
  emailVerified: boolean;
  phone: string | null;
  phoneVerified: boolean;
  lang: Lang;
  avatar: number;
  adultOk: boolean;
  role: "user" | "admin";
  createdAt: number;
}

interface AuthState {
  ready: boolean;
  user: User | null;
}

export const auth = createStore<AuthState>({ ready: false, user: null });

export async function refreshMe(): Promise<User | null> {
  if (IS_DEMO) {
    auth.set({ ready: true, user: null });
    return null;
  }
  try {
    const r = await api<{ ok: true; user: User | null }>("/auth/me");
    auth.set({ ready: true, user: r.user });
    return r.user;
  } catch {
    auth.set((s) => ({ ...s, ready: true }));
    return null;
  }
}

export function setUser(user: User | null) {
  auth.set({ ready: true, user });
}

export async function logout() {
  try {
    await api("/auth/logout", { method: "POST", body: {} });
  } finally {
    auth.set({ ready: true, user: null });
  }
}

export function useAuth() {
  return useStore(auth);
}
